import React from "react";
import { Route, Switch } from "react-router-dom";
import PrivateRoute from "../routing/PrivateRoute";
import AdminRoute from "../routing/AdminRoute";
import AdminOrDeptAdminRoute from "../routing/AdminOrDeptAdminRoute";
import AlertContainer from "../layout/AlertContainer";

import Login from "../auth/LoginLazy";
import ForgotPassword from "../auth/ForgotPasswordLazy";
import ResetPassword from "../auth/ResetPasswordLazy";
import Dashboard from "../dashboard/DashboardLazy";
import UserInfo from "../user/UserInfoLazy";
import ChangeSelfPassword from "../user/ChangeSelfPasswordLazy";
import ManageUsers from "../user/ManageUsersLazy";
import CreateOrUpdateUser from "../user/CreateOrUpdateUserLazy";
import ResetUserPassword from "../user/ResetUserPasswordLazy";
import ManageOrders from "../order/ManageOrdersLazy";
import DownloadExcel from "../order/DownloadExcelLazy";
import ManageItemHierarchy from "../item/ManageItemHierarchyLazy";
import ManageSuppliers from "../supplier/ManageSuppliersLazy";
import ManageProjectIdsMapping from "../projectIdMapping/ManageProjectIdMappingsLazy";
import UpdateAdminSettings from "../adminSettings/UpdateAdminSettingsLazy";
import ManageContract from '../contract/ManageContractsLazy';
import SupplierSuggestion from '../supplierSuggestion/ManageSupplierSuggestionsLazy'
import TemplateManagement from '../templateFile/TemplateManagementLazy';
import ManageSupplierContacts from '../supplierContact/ManageSupplierContactsLazy';
import ManageLoginFailedLogs from '../loginFailedLog/ManageLoginFailedLogsLazy';
import ManageSharePointProcessedFiles from '../sharePointProcessedFile/ManageSharePointProcessedFilesLazy';
import ManageKSDepts from '../ksDept/ManageKSDeptsLazy';
import ManageEmailTemplates from '../emailTemplate/ManageEmailTemplatesLazy';
import VersionHistory from '../versionHistory/VersionHistoryLazy';

import NotFound from "../layout/NotFound";

const Routes = () => {
  return (
    <section className="container-fluid">
      <AlertContainer />
      <Switch>
        <Route exact path="/login" component={Login} />
        <Route exact path="/forgot_pw" component={ForgotPassword} />
        <Route path="/reset_pw/:token" component={ResetPassword} />
        <PrivateRoute exact path="/dashboard" component={Dashboard} />
        <PrivateRoute exact path="/me" component={UserInfo} />
        <PrivateRoute exact path="/change_pw" component={ChangeSelfPassword} />
        <AdminOrDeptAdminRoute exact path="/users" component={ManageUsers} />
        {/* 部門管理員不可新增用戶／修改用戶資料，只可重設密碼 */}
        <AdminRoute exact path="/users/create" component={CreateOrUpdateUser} />
        <AdminRoute
          path="/users/update/:updateUserId"
          component={CreateOrUpdateUser}
        />
        <AdminOrDeptAdminRoute
          path="/users/reset_pw/:updateUserId"
          component={ResetUserPassword}
        />
        <PrivateRoute exact path="/orders" component={ManageOrders} />
        <AdminOrDeptAdminRoute
          exact
          path="/orders/download_excel"
          component={DownloadExcel}
        />
        <AdminOrDeptAdminRoute exact path="/items" component={ManageItemHierarchy} />
        <AdminOrDeptAdminRoute exact path="/suppliers" component={ManageSuppliers} />
        <AdminRoute
          exact
          path="/projectIdMapping"
          component={ManageProjectIdsMapping}
        />
        <AdminOrDeptAdminRoute
          exact
          path="/contract"
          component={ManageContract}
        />
        <AdminOrDeptAdminRoute
        exact
        path="/supplier_suggestion"
        component={SupplierSuggestion}
        />
        <AdminOrDeptAdminRoute
        exact
        path="/template_management"
        component={TemplateManagement}
        />
        <AdminOrDeptAdminRoute
          exact
          path="/admin_settings"
          component={UpdateAdminSettings}
        />
        <PrivateRoute
        exact
        path="/supplier_contact"
        component={ManageSupplierContacts}
        />
        <AdminOrDeptAdminRoute exact path="/login_failed_logs" component={ManageLoginFailedLogs} />
        <AdminOrDeptAdminRoute exact path="/sharepoint_processed_files" component={ManageSharePointProcessedFiles} />
        <AdminOrDeptAdminRoute exact path="/ks_depts" component={ManageKSDepts} />
        <AdminOrDeptAdminRoute exact path="/email_templates" component={ManageEmailTemplates} />
        <PrivateRoute exact path="/version_history" component={VersionHistory} />
        <Route component={NotFound} />
      </Switch>
    </section>
  );
};

export default Routes;
